import { apiClient } from "../../../shared";

/**
 * Flip the news subscription.
 *
 * Pure transport: the endpoint takes no parameters - it toggles whatever value
 * the server currently holds - and this returns the raw response body.
 * Interpreting that body is a domain rule and lives in
 * services/notificationPreferencesService.js.
 *
 * @returns {Promise<unknown>} the response body as sent
 */
export const patchNewsSubscription = async () => {
  const { data } = await apiClient.patch("user/subscribe_to_news");
  return data;
};
